export default __webpack_public_path__ + "3e27683222187b61655f1e0b82e12596.gif";